var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#9C9C9C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 16c0 1.105-.895 2-2 2H4c-1.105 0-2-.895-2-2V6c0-1.105.895-2 2-2h1.5V2.5c0-.276.224-.5.5-.5s.5.224.5.5V4h7V2.5c0-.276.224-.5.5-.5s.5.224.5.5V4H16c1.105 0 2 .895 2 2v10zm-1-6.778H3V16c0 .513.386.936.883.993L4 17h12c.513 0 .936-.386.993-.883L17 16V9.222zm-3.858 1.482c.152.151.172.385.059.558l-.057.07L10.08 14.4c-.36.361-.927.39-1.32.084l-.094-.083-1.81-1.81c-.15-.151-.17-.385-.056-.557l.058-.07c.174-.174.456-.174.63 0l1.815 1.815c.029.03.072.037.108.022l.033-.022 3.068-3.072c.174-.174.456-.175.63-.002zM5.5 5H4c-.513 0-.936.386-.993.883L3 6v2.222h14V6c0-.513-.386-.936-.883-.993L16 5h-1.5v.944c0 .277-.224.5-.5.5s-.5-.223-.5-.5V5h-7v.944c0 .277-.224.5-.5.5s-.5-.223-.5-.5V5z",
    transform: "translate(-613 -277) translate(252 241) translate(134 30) translate(227 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.e9456917.svg";
export { ForwardRef as ReactComponent };